import { Button, Form, Input, Row, Col, Table, Typography, message } from 'antd';
import { useState } from 'react';
import { DateTime } from 'luxon';
import { Cheat } from '../api/go';
import type { DetectionReport } from '../api/go';
import { flattenProcessDataReport, processDataColumns } from './process_data_table';
import type { ProcessDataTableRow } from './process_data_table';

interface QueryForm {
  userId: string;
}

export default function CheatProcessData() {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<ProcessDataTableRow[]>([]);
  const [report, setReport] = useState<DetectionReport | null>(null);

  async function handleQuery(values: QueryForm) {
    const userId = values.userId.trim();
    if (!userId) {
      message.error('请输入 user_id');
      return;
    }

    setLoading(true);
    try {
      const nextReport = await Cheat.processData(userId);
      setReport(nextReport);
      setRows(flattenProcessDataReport(nextReport));
    } catch {
      setReport(null);
      setRows([]);
      message.error('查询失败，请稍后重试');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <Row>
        <Col span={10}>
          <Form<QueryForm>
            name="processData"
            layout="horizontal"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            style={{ maxWidth: 720 }}
            onFinish={handleQuery}
            autoComplete="off"
          >
            <Form.Item<QueryForm> label="User ID" name="userId" required>
              <Input placeholder="请输入 user_id" disabled={loading} />
            </Form.Item>
            <Form.Item label="查询范围">
              <Typography.Text>最近 7 天（含今天）</Typography.Text>
            </Form.Item>
            <Form.Item label={null}>
              <Button type="primary" htmlType="submit" loading={loading}>
                查询
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>

      {report ? (
        <div style={{ marginBottom: 16, textAlign: 'left' }}>
          <Typography.Text>
            原始日志 {report.fetched_log_count} 条，命中日志 {rows.length} 条，时间范围{' '}
            {DateTime.fromISO(report.start).toFormat('yyyy-MM-dd HH:mm:ss')} 至{' '}
            {DateTime.fromISO(report.end).toFormat('yyyy-MM-dd HH:mm:ss')}
          </Typography.Text>
        </div>
      ) : null}

      <Table<ProcessDataTableRow>
        rowKey="log_id"
        loading={loading}
        dataSource={rows}
        columns={processDataColumns}
        scroll={{ x: 1600 }}
        pagination={false}
      />
    </div>
  );
}
